import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIList from 'UIComponents/list/UIList';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { GOAL_MILESTONE } from 'goals-reporting-lib/constants/goals';
import { Set as ImmutableSet } from 'immutable';
const GOAL_DURATIONS = [GOAL_MILESTONE.MONTHLY, GOAL_MILESTONE.QUARTERLY, GOAL_MILESTONE.YEARLY];

const getFilterButtonText = durations => {
  if (durations.size === 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `goals-reporting-lib.table.milestone.values.${durations.first()}`
    });
  }

  if (durations.size === GOAL_DURATIONS.length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.anyDuration"
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "filters.multipleDurations",
    options: {
      count: durations.size
    }
  });
};

const GoalDurationFilter = ({
  onChangeDurations,
  selectedDurations
}) => {
  const onChange = newDuration => {
    return event => {
      const updatedDurations = event.target.checked ? selectedDurations.add(newDuration) : selectedDurations.delete(newDuration);

      if (updatedDurations.size) {
        onChangeDurations(updatedDurations);
      } else {
        onChangeDurations(ImmutableSet(GOAL_DURATIONS));
      }
    };
  };

  const getOption = duration => {
    return /*#__PURE__*/_jsx(UICheckbox, {
      checked: selectedDurations.has(duration),
      onChange: onChange(duration),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `goals-reporting-lib.table.milestone.values.${duration}`
      })
    }, duration);
  };

  const entityDurations = GOAL_DURATIONS;
  const options = entityDurations.map(getOption);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.durationFilterLabel"
    }),
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "link",
      buttonText: getFilterButtonText(selectedDurations),
      menuWidth: 250,
      children: /*#__PURE__*/_jsx(UIList, {
        children: options
      })
    })
  });
};

export default GoalDurationFilter;